import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  button: {
    color: theme.palette.grey[500],
    padding: 0,
  },
}));

export default useStyles;
